import type { ResumoDashboard } from "@base/contracts";

export const ROTULOS_STATUS: Record<string, string> = {
  rascunho: "Rascunho",
  em_producao: "Em produção",
  revisao: "Revisão",
  aprovado: "Aprovado",
  publicado: "Publicado",
  pausado: "Pausado",
  draft: "Rascunho",
  queued: "Na fila",
  scheduled: "Agendado",
  publishing: "Publicando",
  published: "Publicado",
  failed: "Falhou",
};

export const ROTULOS_FORMATO: Record<string, string> = {
  feed: "Feed",
  carrossel: "Carrossel",
  reels: "Reels",
  stories: "Stories",
};

export const ROTULOS_PLATAFORMA: Record<string, string> = {
  instagram: "Instagram",
  facebook: "Facebook",
  twitter: "X",
  tiktok: "TikTok",
};

export const DIAS_SEMANA = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"] as const;

export function formatarPercentual(valor: number | null): string {
  if (valor === null) return "Sem dados";
  return `${Math.round(valor * 100)}%`;
}

export function formatarNumero(valor: number): string {
  return new Intl.NumberFormat("pt-BR").format(Math.round(valor));
}

export function formatarHorario(hora: number | null): string {
  if (hora === null) return "Sem dados";
  return `${String(hora).padStart(2, "0")}:00`;
}

export function formatarDelta(delta: number | null): string {
  if (delta === null) return "n/d";
  const sinal = delta > 0 ? "+" : "";
  return `${sinal}${delta.toFixed(0)}%`;
}

export function formatarDataCurta(iso: string | null): string {
  if (!iso) return "Ainda não houve coleta";
  return new Intl.DateTimeFormat("pt-BR", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(new Date(iso));
}

export function mesAtualIso(): string {
  const agora = new Date();
  const mes = String(agora.getUTCMonth() + 1).padStart(2, "0");
  return `${agora.getUTCFullYear()}-${mes}`;
}

export function dadosStatusPipeline(resumo: ResumoDashboard) {
  return Object.entries(resumo.produtividade.postsPorStatus)
    .map(([status, quantidade]) => ({
      status,
      rotulo: ROTULOS_STATUS[status] ?? status,
      quantidade,
    }))
    .sort((a, b) => b.quantidade - a.quantidade);
}
